// The forms DatePicker reports a change as an event (single date) or a range object, SearchBar's callers get
// onDateChange(startDate, endDate) with YYYY-MM-DD strings

export interface DateChange {
    startDate: string
    endDate: string
}

type DatePickerValue = {target: {value: string}} | {startDate: string, endDate: string}

/**
 * The dates to report for a DatePicker change, or null when there is nothing to report yet: noBubble is the first
 * click of a range (the end date follows), and an empty date can't be filtered on. A single date is a range of one day.
 */
export function getDateChange(eventOrRange: DatePickerValue, noBubble?: boolean): DateChange | null {
    if (noBubble) {
        return null
    }

    if ('target' in eventOrRange) {
        const date = eventOrRange.target.value

        return date ? {startDate: date, endDate: date} : null
    }

    const {startDate, endDate} = eventOrRange
    if (!startDate || !endDate) {
        return null
    }

    // YYYY-MM-DD strings sort like the dates they are
    return startDate <= endDate ? {startDate, endDate} : {startDate: endDate, endDate: startDate}
}
